import React from "react"
import styled from "styled-components"
import { components } from "react-select"

import { ParagraphSmall } from "components/text"
import poweredByGoogle from "assets/powered-by-google.png"

export const PoweredByGoogle = styled.img.attrs({
  src: poweredByGoogle,
  alt: "Powered by Google"
})`
  float: right;
  width: ${props => props.theme.space[9]};

  padding: ${props => props.theme.space[2]};
`

export const MenuList: React.FC<any> = props => (
  <>
    {props.isLoading ? (
      <ParagraphSmall p={4}>Loading...</ParagraphSmall>
    ) : (
      <>
        <components.MenuList {...props}>{props.children}</components.MenuList>
        {props.options.length > 0 && <PoweredByGoogle />}
      </>
    )}
  </>
)

export const ValueContainer: React.FC<any> = ({ children, ...props }) => (
  <components.ValueContainer {...props}>
    <components.Placeholder {...props} isFocused={props.isFocused}>
      {props.selectProps.placeholder}
    </components.Placeholder>
    {React.Children.map(children, child => (child && child.type !== components.Placeholder ? child : null))}
  </components.ValueContainer>
)
